import ProgressivePromise from '@aytm/lib/AsyncJobManager/ProgressivePromise'
import railsPostFetch, { getCSRFToken } from '@aytm/lib/common/rails-post-fetch'
import fetch from 'isomorphic-fetch'
import uploadWithProgress from '@aytm/lib/common/upload-with-progress'

export default function AssetUploadJob({ file, uploadUrl, statusUrl, contentType, params = {} } = {}) {
  return new ProgressivePromise((resolve, reject, progress) => {
    const totalProgress = file.size
    // CREATE ASSET

    progress(0, totalProgress) // set progress to 0

    const uploadParams = Object.assign({}, params, {
      filename: file.name
    })

    const asset = {}

    railsPostFetch(uploadUrl, {
      credentials: 'omit',
      mode: 'cors',
      cache: 'no-cache',
      body: JSON.stringify(uploadParams)
    })
      .then(response => (response.ok ? response.json() : {}))

      // UPLOAD ASSET
      .then(data => {
        if (!data || !data.url) {
          return Promise.reject(new Error('AssetUploadJob - invalid response data'))
        }

        Object.assign(asset, { id: data.fileId })

        return uploadWithProgress(
          data.url,
          {
            method: 'PUT',
            headers: {
              'Content-Type': contentType || file.type
            },
            body: file
          },
          progressEvent => {
            progress(Math.round(progressEvent.loaded * 0.9), totalProgress) // set progress for uploaded bytes with correction 100% -> 90%
          }
        )
      })

      // FINISH UPLOAD
      .then(() =>
        fetch(`${statusUrl}/${asset.id}`, {
          method: 'POST',
          credentials: 'omit',
          mode: 'cors',
          cache: 'no-cache',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': getCSRFToken()
          },
          Accept: 'application/json',
          body: JSON.stringify(uploadParams)
        })
      )
      .then(response => (response.ok ? response.json() : {}))

      // CHECK STATUS
      .then(data => {
        if (data.file) {
          Object.assign(asset, { md5: data.file.md5 })

          progress(Math.round(file.size * 0.95), totalProgress) // set progress to 95%
          return new Promise((resolve, reject) => {
            const checkStatus = () => {
              fetch(`${statusUrl}/${asset.id}/${asset.md5}`, {
                method: 'POST',
                credentials: 'omit',
                mode: 'cors',
                cache: 'no-cache',
                headers: {
                  'Content-Type': 'application/json',
                  'X-CSRF-Token': getCSRFToken()
                },
                Accept: 'application/json',
                body: JSON.stringify(params)
              })
                .then(response => (response.ok ? response.json() : {}))
                .then(uploadStatus => {
                  switch (uploadStatus.status) {
                    case 'OK': {
                      progress(totalProgress, totalProgress) // set progress to 100%
                      resolve({ asset, result: uploadStatus })
                      break
                    }
                    case 'RUNNING': {
                      setTimeout(checkStatus, 1000)
                      break
                    }
                    default: {
                      reject(uploadStatus)
                      break
                    }
                  }
                })
                .catch(_error => {
                  setTimeout(checkStatus, 1000)
                })
            }
            setTimeout(checkStatus, 500)
          })
        } else {
          return Promise.reject(new Error('AssetUploadJob - unable to finish upload'))
        }
      })
      .then(resolve, reject)
      .catch(error => reject(error))
  })
}
